import { Link, useNavigate, useParams } from "react-router-dom";
import { useContext, useEffect, useState } from "react";
import { UserContext } from "../App";
import useInvoke from "../Tools/Invoker";
import DynamicGrid from "../Tools/DynamicGrid";
import LoginRedirect from "../Page/LoginRedirect";
import CheckToken from "../_Login/CheckToken";
import toast, { Toaster } from 'react-hot-toast';
import CustomerSave from "./CustomerSave";


const CustomerNew = () => {

    const [user, setUser] = useContext(UserContext);
    let navigate = useNavigate();
    CheckToken(user["id"], user["token"]).then((result) => {if(!result) {setUser({}); navigate("/Login");}});

    let response32 = useInvoke("WebApps", "32", null);

    useEffect(() => {

        //get states
        if (response32.data.payload != undefined) {
            let data = JSON.parse(response32.data.payload).data;

            let select = document.getElementById("stateID");

            let defaultOption = document.createElement('option');
            defaultOption.text = "Select State";
            defaultOption.value = "";
            select.options.add(defaultOption);

            data.forEach(state => {
                let option = document.createElement('option');
                option.text = state[1];
                option.value = state[0];
                select.options.add(option);
            });
        }

    }, [response32.isPending]);

    const handleFormSubmit = (e) => {

        let customerid = "";

        let valid = true;

        let customername = "";
        if (document.getElementById("customername").value != "") {
            customername = document.getElementById("customername").value;
        }
        else {
            valid = false; 
            toast.error("Customer Name required");
        }

        let customerabbr = "";
        if (document.getElementById("customerabbr").value != "") {
            customerabbr = document.getElementById("customerabbr").value;
        }
        else {
            valid = false; 
            toast.error("Customer Abbr required");
        }

        let address = "";
        if (document.getElementById("address").value != "") {
            address = document.getElementById("address").value;
        }
        else {
            valid = false; 
            toast.error("Customer Address required");
        }

        let city = "";
        if (document.getElementById("city").value != "") {
            city = document.getElementById("city").value;
        }
        else {
            valid = false; 
            toast.error("City required");
        }

        let stateid = "";
        if (document.getElementById("stateID").value != "") {
            stateid = document.getElementById("stateID").value;
        }
        else {
            valid = false;
            toast.error("State required");
        }

        let postalcode = "";
        if (document.getElementById("postalcode").value != "") {
            postalcode = document.getElementById("postalcode").value;
        }
        else {
            valid = false; 
            toast.error("Postal Code required");
        }

        let modifiedbyid = user["id"];
        let deleted = "0";

        if (valid) {
           CustomerSave (customerid, customername, customerabbr, address, city, stateid, postalcode, modifiedbyid, deleted);
           toast.success('Success');
           navigate("/Customer");
        }
    };

    document.title = "Customers - New";
    return ( 
        <div className="customerNew">

            {user["email"] != undefined && 
                <>
                    <div className="container body-content" style={{marginTop: "25px"}}>
                            
                    <h2>New Customer</h2>

                        <form id="customerForm" noValidate="novalidate" autoComplete="off">    

                            <div className="form-group">
                                <label htmlFor="customername">Customer Name</label>
                                <input className="form-control" id="customername" name="customername" type="text" autocomplete="off" />
                            </div>

                            <div className="form-group">
                                <label htmlFor="customerabbr">Customer Abbr</label>
                                <input className="form-control" id="customerabbr" name="customerabbr" type="text" autocomplete="off" />
                            </div>

                            <div className="form-group">
                                <label htmlFor="address">Customer Address</label>
                                <input className="form-control" id="address" name="address" type="text" autocomplete="off" />
                            </div>

                            <div className="form-group">
                                <label htmlFor="city">Customer City</label>
                                <input className="form-control" id="city" name="city" type="text" autocomplete="off" />
                            </div>

                            <div className="form-group">
                                <label htmlFor="stateID">Customer State / Province</label>
                                <select className="form-control" id="stateID" name="stateID"></select>
                            </div>

                            <div className="form-group">
                                <label htmlFor="postalcode">Customer Postal Code</label>
                                <input className="form-control" id="postalcode" name="postalcode" type="text" autocomplete="off" />
                            </div>

                        </form>   
                        <Link to="/Customer" className="btn btn-default" style={{marginRight: "4px"}}>Cancel</Link>                         
                        <button onClick={handleFormSubmit} className="btn btn-primary" style={{marginRight: "4px"}}>Save</button>                        
                    </div>
                </>
            }
        </div>
     );
}
 
export default CustomerNew;